<h3 mat-dialog-title>{{'auswahl' | translate}}...</h3>
<mat-dialog-content class="mat-typography">
  <div *ngIf="data.ref.optionsGroups">
    <mat-selection-list #list style="overflow: hidden;">

      <div *ngFor="let group of data.ref.optionsGroups; let index=index;">
        <mat-divider *ngIf="index!=0" class="mb-2"></mat-divider>
        <div class="d-flex flex-row-reverse align-items-center justify-content-between">
          <button mat-raised-button *ngIf="!showSelectUnselectButton(group)" (click)="selectAllOptionsFromGroup(list, group)">{{'selectAll' | translate}}</button>
          <button mat-raised-button *ngIf="showSelectUnselectButton(group)" (click)="unselectAllOptionsFromGroup(list, group)">{{'unselectAll' | translate}}</button>

          <span mat-subheader style="font-size:18px; font-weight:bold; color:black;">{{ group | translate }}</span>
        </div>
        <div *ngFor="let opt of getOptionsForSpecificGroup(group)">
          <mat-list-option (click)="onAreaListControlChanged(list,group)" *ngIf="opt.item.optionGroup == group" [selected]="opt.selected" [value]="opt">
            {{getTitle(opt.item)}}
          </mat-list-option>
        </div>
      </div>
    </mat-selection-list>
  
  </div>

  <div *ngIf="!data.ref.optionsGroups">
    <mat-selection-list #list style="overflow: hidden;">
      <mat-list-option (click)="onAreaListControlChanged(list,group)" *ngFor="let opt of data.ref.options" [selected]="opt.selected" [value]="opt">
        {{getTitle(opt.item)}}
      </mat-list-option>
    </mat-selection-list>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button class="first-btn" [mat-dialog-close]="true">Ok</button>
</mat-dialog-actions>
